'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CMS_ACTION_TYPES = exports.CMS_ACTION_TYPES = {
  OFFER_CHECKOUT: 'offerCheckout',
  RAF: 'referAFriend',
  YOUTUBE_VIDEO: 'youtubeVideo',
  URL: 'actionLink'
};